// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import InitialConfigHeader from '../../../components/InitialConfig/UserInitialConfigHeader';
import StepIntro from '../../../components/InitialConfig/StepIntro'
import ListDevicesApps from '../../../components/InitialConfig/ListDevicesApps'
import AsideMenu from '../../../components/InitialConfig/AsideMenu'
import WorkflowNavigationButtons from '../../../components/InitialConfig/WorkflowNavigationButtons';
import WorkflowIlustration from "../../../components/InitialConfig/WorkflowIlustration";
import ReactGA from "react-ga4";

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js");
var generalCommonJS = require("../../../js/generalCommon.js")

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const getInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/getInstallationConfiguration"

// Initial config - Devices
const Devices = () => {

  const [selectedLocation, setSelectedLocation] = useState([{ id: "", distance: "", lat: "40.4167754", long: "-3.7037902" }]) //Default Madrid

  useEffect(() => {    

    if(initialConfigCommonJS.antiBackOnboarding() === false){

      if(localStorage.getItem("installationConfigurationMode") === null){
        localStorage.removeItem("currentInstallationConfiguration")
        localStorage.removeItem("configuredApps")
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGISTRO', 'REGISTRO - DISPOSITIVOS', "", "")
      }

      initialConfigCommonJS.actualizarPasoWorkflowEnBBDD("DEVICES")
      localStorage.removeItem("deviceToConfigure")

      if(localStorage.getItem("currentInstallationConfiguration") !== null){         
        document.getElementById("listadoAplicacionesConfiguradas").style = "display: none"
        procesarConfiguracionActual(JSON.parse(localStorage.getItem("currentInstallationConfiguration")))
      }
      else{
        cargarConfiguracionActualPaso()        
      }

      if(localStorage.getItem("installationConfigurationMode") !== null){
        document.getElementById("devices").className = "step"      
        document.getElementById("botonContinuar").style="display:none"
        initialConfigCommonJS.visibilidadModoConfiguracion()
        document.getElementById("initialConfigBreadcrumb").className = document.getElementById("initialConfigBreadcrumb").className.replaceAll(" hidden", "") + " hidden"
      }    
      else{
        document.title = "HELIAS - Configuración inicial: Dispositivos inteligentes"
      }
    }
    
  }, []);

  const [appToConsult, setAppToConsult] = useState("")
  const [devicesApps, setDevicesApps] = useState([])
  const [devicesList, setDevicesList] = useState([])
  const [illustrationElements, setIllustrationElements] = useState([]) 

  function procesarConfiguracionActual(jsonRespuesta){

    setIllustrationElements(initialConfigCommonJS.cargaInicialIlustracion(jsonRespuesta))
 
  }

  function cargarConfiguracionActualPaso(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    

    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "GeneralInfo": "",
      "Meteo": "",
      "FV": "",
      "Battery": "",
      "Generator": "",
      "Cars": "",
      "Messaging": ""
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            procesarConfiguracionActual(jsonRespuesta.body)  
            console.log("Información cargada correctamente")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {  
          initialConfigCommonJS.mostrarMensajeInformativo('Se produjo un error al cargar la configuracion.',"negative")
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);      
  }

  function navegar(direccion){      
    if(initialConfigCommonJS.existeSesion()){      
      if(localStorage.getItem("ongoingStepConfiguration") === "DEVICES"){      
        initialConfigCommonJS.navegarDinamico(direccion)
      }
      else{
        initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
      }
    }
  }

  return (          
    <main id="divMainContenedorStep">      

      <InitialConfigHeader step={"DEVICES"}/>

      <section id="devices" className="step wrapper">
        <div id="divContenedorStep" className="content-wrapper half">

          <StepIntro 
            Title="Dispositivos inteligentes" 
            Intro={<p>Estas son las aplicaciones que tienes configuradas hasta ahora para controlar dispositivos inteligentes. Si echas en falta alguna más que tengas (Ej: Para luces, enchufes, etc...) regístralas ahora. Recuerda que podrás controlarlos todos desde Helias y establecer reglas aun siendo de marcas diferentes.</p>}
          />  

          <ListDevicesApps devicesApps={devicesApps} setDevicesApps={setDevicesApps} setDevicesList={setDevicesList} setAppToConsult={setAppToConsult}/>

          <WorkflowNavigationButtons step={"DEVICES"} navegar={navegar}/>

        </div>

        { localStorage.getItem("installationConfigurationMode") === null
          ? <WorkflowIlustration illustrationElements={illustrationElements}/>
          : <></>
        }

      </section>

      <AsideMenu devicesList={devicesList} setDevicesList={setDevicesList} appToConsult={appToConsult} setAppToConsult={setAppToConsult} setDevicesApps={setDevicesApps} selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation}/>

    </main>
    
  )
}

export default Devices